import axios from 'axios';
import {apiService} from "../../services/api.service";
import {extractData, handleResponse} from "../../helpers/apiResponseHelper";
import { PartnerCredentialForm, PartnerCredentialStatus } from 'components/Partners/models';

async function createPartnerCredential(partnerId: number, request: PartnerCredentialForm) {
    return axios.post(`${apiService.getApiUrl()}/partner-credentials/admin`,
        {
            partnerId,
            ...request
        }).then(handleResponse).then(extractData);
}

async function revokePartnerCredential(credentialId: number) {
    return axios.post(`${apiService.getApiUrl()}/partner-credentials/admin/${credentialId}/revoke`)
        .then(handleResponse);
}

async function updatePartnerCredentialStatus(credentialId: number, status: PartnerCredentialStatus) {
    return axios.patch(`${apiService.getApiUrl()}/partner-credentials/admin/${credentialId}/status`,
        {status}
    ).then(handleResponse);
}

export const PartnerCredentialService = {
    createPartnerCredential,
    revokePartnerCredential,
    updatePartnerCredentialStatus
};
